import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { AttendanceLogicComponentListSearchSchema } from '../-shared/attendance-logic-component-list-search-schema';
export const Route = createFileRoute('/_staff/attendance-engine/_layout/logic-components/')({
  validateSearch: zodValidator(AttendanceLogicComponentListSearchSchema)
});